import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/**
 * Blocks gateway queries are `get<Collection>` and pluralize by the literal schema name + "s"
 * (`SkillCategorys`, `SkillSubCategorys`, `Skills`); each is aliased so services read `result.<Collection>`.
 *
 * The old app had no skill manager (skills were a fixed list), so these A to Z default sorts are the
 * new screen's own.
 */
const PAGING_FIELDS = `
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo`;

export const DEFAULT_SKILL_CATEGORIES_ORDER: OrderBy[] = [{ field: 'Title', direction: 'ASC' }];

export const buildGetSkillCategoriesQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_SKILL_CATEGORIES_ORDER
) => `
  query {
    SkillCategorys: getSkillCategorys(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {${PAGING_FIELDS}
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        Title
      }
    }
  }
`;

export const DEFAULT_SKILL_SUB_CATEGORIES_ORDER: OrderBy[] = [{ field: 'Title', direction: 'ASC' }];

export const buildGetSkillSubCategoriesQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_SKILL_SUB_CATEGORIES_ORDER
) => `
  query {
    SkillSubCategorys: getSkillSubCategorys(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {${PAGING_FIELDS}
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        Title
      }
    }
  }
`;

export const DEFAULT_SKILLS_ORDER: OrderBy[] = [{ field: 'Name', direction: 'ASC' }];

export const buildGetSkillsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_SKILLS_ORDER
) => `
  query {
    Skills: getSkills(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {${PAGING_FIELDS}
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        Name
        SubCategoryId
      }
    }
  }
`;
